import { useIsRestoring, useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../api";



export const useGetCompany = (queryParams={}) => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ["company"],
        queryFn: async () => (await api.get("/company/")).data[0],
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        ...queryParams,
    });
};
        

export const useUpdateCompany = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["company"],
        mutationFn: async ({id, ...data}) => (await api.patch(`/company/${id}/`, data)).data,
        onSuccess: (data) => {
            console.log(data);
            queryClient.setQueryData(["company"], data);
        }
    });

}